
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vn/ve-may-bay/[slug]",
      function () {
        return require("private-next-pages/vn/ve-may-bay/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vn/ve-may-bay/[slug]"])
      });
    }
  